// extracted by mini-css-extract-plugin
export default {"link":"ButtonTVL_link__83DRd","active":"ButtonTVL_active__QAKmy"};